import type { User } from '../types/user'

/**
 * Stand-in signed-in user until `useAuth()` is wired up. Replace each
 * import site with the real hook output once the auth API lands — the
 * `User` shape is a stable contract.
 *
 * Tenant branding is no longer stubbed here: `useTenantBranding()`
 * pulls the live tenant details from `GET /auth/tenants/{tenantId}`.
 */
export const stubUser: User = {
  id: 'me',
  name: 'Sarah Connor',
  email: 'sarah.connor@orolabs.ai',
  role: 'Procurement Manager',
}
